
import './Sass/main.sass'
import './Sass/includes/Components/modules/countries.sass'
import ModulosPeopleContainer from "./Containers/People/Modules";
function App() {
  return (
    <div className="App">
      <ModulosPeopleContainer/>
    </div>
  );
}

export default App;
